import { render, staticRenderFns } from "./CompanyNoteCard.vue?vue&type=template&id=3922cbb4&"
import script from "./CompanyNoteCard.vue?vue&type=script&lang=ts&"
export * from "./CompanyNoteCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports